import { useParams, useSearchParams } from 'react-router-dom'
import { useUser } from '../../../context/UserProvider'
import CarCard from './CarCard'

export function CarDetailsWrapper() {
  const user = useUser()
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type')
  const { id } = useParams()
  if (!user?.user) {
    return null
  }

  return <CarCard user={user} type={type} id={id} />
}
